import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=2919a327&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=2919a327&prod&lang=scss"
import style1 from "./detail.vue?vue&type=style&index=1&id=2919a327&prod&lang=css"
import style2 from "./detail.vue?vue&type=style&index=2&id=2919a327&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2919a327",
  null
  
)

export default component.exports